import styles from "./PrivacyPolicy.module.css";

const EMAIL = "aquitem.sistema@gmail.com"; // ← troque pelo e-mail real

const SECTIONS = [
  {
    num: "1",
    title: "Coleta de informações",
    type: "list",
    items: [
      "Token de dispositivo para envio de notificações push via Firebase",
      "Preferências de notificação salvas localmente no dispositivo",
      "Dados de uso do aplicativo para fins de melhoria do serviço",
    ],
  },
  {
    num: "2",
    title: "Uso das informações",
    type: "list",
    items: [
      "Envio de alertas sobre novos encartes e ofertas do comércio local",
      "Personalização da experiência de notificações conforme preferência do usuário",
      "Melhoria contínua da performance e estabilidade do aplicativo",
    ],
  },
  {
    num: "3",
    title: "Compartilhamento de dados",
    type: "text",
    text: "Os dados não são vendidos a terceiros. O token de dispositivo é processado exclusivamente pelo Firebase Cloud Messaging (Google) para entrega de notificações, conforme os termos de uso do Firebase.",
  },
  {
    num: "4",
    title: "Notificações push",
    type: "text",
    text: "O aplicativo solicita permissão antes de enviar notificações. O usuário pode ativar ou desativar notificações a qualquer momento nas configurações do app ou nas configurações do sistema operacional.",
  },
  {
    num: "5",
    title: "Segurança",
    type: "text",
    text: "Adotamos boas práticas de segurança para proteger os dados contra acessos não autorizados. As preferências do usuário são armazenadas localmente no dispositivo e não são transmitidas a servidores externos além do necessário para o funcionamento das notificações.",
  },
  
];

function PrivacyPolicy() {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Política de Privacidade – AquiTem</h1>

      <p className={styles.intro}>
        Descreve como o aplicativo <strong>AquiTem</strong> coleta, usa e
        protege as informações dos usuários.
      </p>

      <hr className={styles.divider} />

      {SECTIONS.map(({ num, title, type, items, text }) => (
        <div key={num} className={styles.section}>
          <div className={styles.sectionHead}>
            <div className={styles.num}>{num}</div>
            <h2 className={styles.sectionTitle}>{title}</h2>
          </div>

          {type === "list" && (
            <ul className={styles.list}>
              {items?.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
          )}

          {type === "text" && (
            <p className={styles.bodyText}>{text}</p>
          )}
        </div>
      ))}

      <div className={styles.section}>
        <div className={styles.sectionHead}>
          <div className={styles.num}>7</div>
          <h2 className={styles.sectionTitle}>Contato</h2>
        </div>
        <a href={`mailto:${EMAIL}`} className={styles.contactCard}>
          <span className={styles.contactLabel}>Suporte:</span>
          <span className={styles.contactEmail}>{EMAIL}</span>
        </a>
      </div>

      <p className={styles.footer}>
        Última atualização:{" "}
        {new Date().toLocaleDateString("pt-BR", { month: "long", year: "numeric" })}
      </p>
    </div>
  );
}

export default PrivacyPolicy;
